// extracted by mini-css-extract-plugin
export default {"goals":"jGK2X","items":"wfa6G","item":"BKR1P","itemControl":"z1jp1","action":"qHqx7"};